<!-- Header -->
<div class="dialog-header" [ngClass]="{ 'green-bg': data.isAffiliate }">
  <img src="assets/image/submit-dialog.svg" />

  <ng-container *ngIf="data.insuranceType == 'COM' && data.isVehicleOverAged">
    <div>{{ "fail.OverAgedForCOMHeader" | translate }}</div>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TPFT'">
    <ng-container *ngIf="data.isVehicleUnderAged">
      <div>{{ "fail.UnderAgedForTPFTHeader" | translate }}</div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
      <div>{{ "fail.OverAgedForTPFTHeader" | translate }}</div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TP'">
    <ng-container *ngIf="data.isVehicleUnderAged">
      <div>{{ "fail.UnderAgedForTPHeader" | translate }}</div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
      <div>{{ "fail.OverAgedForTPHeader" | translate }}</div>
    </ng-container>
  </ng-container>
</div>

<!-- Content -->
<div class="dialog-content">

  <!-- TODO: E-Hailing Version? -->

  <ng-container *ngIf="data.insuranceType == 'COM' && data.isVehicleOverAged">
    <div [innerHTML]="'fail.OverAgedForCOMLine1' | translate"></div>
    <div [innerHTML]="'fail.OverAgedForCOMLine2' | translate"></div>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TPFT'">
    <ng-container *ngIf="data.isVehicleUnderAged">
    <div [innerHTML]="'fail.UnderAgedForTPFTLine1' | translate"></div>
    <div [innerHTML]="'fail.UnderAgedForTPFTLine2' | translate"></div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
    <div [innerHTML]="'fail.OverAgedForTPFTLine1' | translate"></div>
    <div [innerHTML]="'fail.OverAgedForTPFTLine2' | translate"></div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TP'">
    <ng-container *ngIf="data.isVehicleUnderAged">
    <div [innerHTML]="'fail.UnderAgedForTPLine1' | translate"></div>
    <div [innerHTML]="'fail.UnderAgedForTPLine2' | translate"></div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
    <div [innerHTML]="'fail.OverAgedForTPLine1' | translate"></div>
    <div [innerHTML]="'fail.OverAgedForTPLine2' | translate"></div>
    </ng-container>
  </ng-container>

  <div>{{ "common.thankyou" | translate }}.</div>
</div>

<!-- Footer -->
<div class="dialog-footer">
  <!-- Whatsapp Button -->
  <button *ngIf="showWhatsappButton"
    class="btn"
    [ngClass]="data.isAffiliate ? 'green-btn' : 'btn-primary'"
    mat-stroked-button
    mat-dialog-close
    (click)="whatsppRedirect()"
  >
    {{ "common.WhatsApp" | translate }}
  </button>

  <!-- Close Button -->
  <button
    class="btn"
    [ngClass]="{ 'green-btn-outline': data.isAffiliate }"
    mat-stroked-button
    (click)="onBackToHome()"
  >
    {{ "success.close" | translate }}
  </button>
</div>


<!--
<div class="dialog-header" [ngClass]="{ 'green-bg': data.isAffiliate }">
  <img src="assets/image/submit-dialog.svg" />
  <div>{{ "fail.requestFailed" | translate }}</div>
</div>
<div class="dialog-content">
  <ng-container *ngIf="data.isWithEHailing; else notEhailing">
    <div
      [innerHTML]="
        'fail.vehicleAgeLimitWithEHailing' | translate : { numOfYears: maxYear }
      "
    ></div>
  </ng-container>

  <ng-template #notEhailing>
    <ng-container *ngIf="data.isTpftVehicleOverage; else notTpft">
      <div [innerHTML]="'fail.tpftVehicleAgeLimit' | translate"></div>
    </ng-container>

    <ng-template #notTpft>
      <div
        [innerHTML]="
          'fail.vehicleAgeLimit' | translate : { numOfYears: maxYear }
        "
      ></div>

      <ng-container *ngIf="data.partnerCode !== 'ktmb'">
        <div [innerHTML]="'fail.vehicleAgeLimit2' | translate"></div>

        <div>{{ "common.thankyou" | translate }}.</div>
      </ng-container>
    </ng-template>
  </ng-template>
</div>

<div class="dialog-footer">
  <button
    *ngIf="showReqBtn"
    class="btn"
    [ngClass]="data.isAffiliate ? 'green-btn' : 'btn-primary'"
    mat-stroked-button
    mat-dialog-close
    (click)="onRequest()"
  >
    {{ "fail.requestQuote" | translate }}
  </button>
  <button
    class="btn"
    [ngClass]="{ 'green-btn-outline': data.isAffiliate }"
    mat-stroked-button
    (click)="onBackToHome()"
  >
    {{ "success.close" | translate }}
  </button>
</div>
-->